import { MdKeyboardArrowRight } from "react-icons/md"
import { Link, useLocation } from "react-router-dom"

const BreadCrumbs = () => {
    const location = useLocation()

    let currentLink = ''

    const crumbs = location.pathname.split('/')
        .filter(crumb => crumb !== '')
        .map((crumb, index) => {
            currentLink += `/${crumb}`
            //replace %20 with space
            const breadCrumb = decodeURIComponent(crumb).replace(/%20/g, ' ')
            return (
                <div className="flex gap-2 sm:gap-5 items-center" key={crumb}>
                    {
                        index > 0
                        &&
                        <span className="text-gray-200">
                            <MdKeyboardArrowRight size={25} />
                        </span>
                    }
                    <Link className="" to={currentLink}>{breadCrumb.split("-").join(" ")}</Link>
                </div>
            )
        })
    return (
        <div className="flex gap-1 sm:gap-3 capitalize text-slate-200 font-bold whitespace-nowrap text-[10px] xs:text-[15px]  sm:text-lg items-center">
            <Link to={"/"}>Home</Link>
            <span className="text-gray-200 font-bold">
                <MdKeyboardArrowRight size={26} />
            </span>
            {crumbs}
        </div>
    )
}

export default BreadCrumbs